document.addEventListener('DOMContentLoaded', function () {
  const lang = document.documentElement.getAttribute('lang');
  if (lang !== 'ko') return;

  function splitMenuText(selector, symbol) {
    const menuLinks = document.querySelectorAll(selector);
    menuLinks.forEach(link => {
      if (link.dataset.splitProcessed) return;
      const text = link.textContent.trim();
      const enMatch = text.match(/[A-Za-z0-9\s.,!?"'\-]+/g);
      const koMatch = text.match(/[\uac00-\ud7af\u1100-\u11ff\u3130-\u318f]+/g);
      const en = enMatch ? enMatch.join(' ').trim() : '';
      const ko = koMatch ? koMatch.join(' ').trim() : '';
      let newHTML = '';
      if (en) newHTML += `<span class="en">${en}</span>`;
      if (ko) newHTML += `<span class="ko">${symbol}${ko}</span>`;
      link.innerHTML = newHTML;
      link.dataset.splitProcessed = "true";
    });
  }

  function splitPageTitle(selector) {
    const pageTitle = document.querySelector(selector);
    if (!pageTitle || pageTitle.dataset.splitProcessed) return;

    const text = pageTitle.textContent.trim();
    const firstKoIndex = text.search(/[\uac00-\ud7af\u1100-\u11ff\u3130-\u318f]/);
    let en = '';
    let ko = '';

    if (firstKoIndex !== -1) {
      en = text.slice(0, firstKoIndex).trim().replace(/\s*\/\s*$/, '');
      ko = text.slice(firstKoIndex).trim();
    } else {
      en = text;
    }

    let newHTML = '';
    if (en) newHTML += `<span class="en">${en}</span>`;
    if (ko) newHTML += `<span class="ko"> / ${ko}</span>`;
    pageTitle.innerHTML = newHTML;
    pageTitle.dataset.splitProcessed = "true";
  }

  splitMenuText('.section-header .header .main-nav.bold ul li a', ' / ');
  splitMenuText('.side-nav .menu ul li a', ' ');
  splitMenuText('[data-collection-product-title]', ' / ');
  splitPageTitle('[data-product-title]');
  splitPageTitle('[data-mce-href]');

  const observer = new MutationObserver(mutations => {
    for (const mutation of mutations) {
      if (mutation.addedNodes.length) {
        splitMenuText('[data-collection-product-title]', ' / ');
        splitPageTitle('[data-product-title]');
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});